import PropTypes from "prop-types";
import { Paper, FormLabel } from "@mui/material";
import DnDFileUpload from "../components/DnDFileUpload.jsx";
import { componentTokens } from "../../../theme/tokens/components.js";

Upload.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
};

export default function Upload(props) {
  const { item, value, onChange, disabled = false } = props;

  const convertToDefEventPara = (value) => {
    onChange({
      target: {
        name: item.name,
        value,
      },
    });
  };

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: componentTokens.formSection.backgroundColor,
        borderRadius: componentTokens.formSection.borderRadius,
        height: "100%",
        width: "100%",
        p: componentTokens.formSection.padding,
        margin: "0px",
      }}
    >
      <FormLabel
        filled={true}
        sx={{ mb: componentTokens.formSection.padding, display: "block" }}
      >
        {item.label}
      </FormLabel>
      <DnDFileUpload
        upload={value}
        multiple={item.multiple || false}
        add_description={item.add_description || false}
        setUpload={convertToDefEventPara}
        allowedExtensions={
          item.allowedExtensions || ["JPG", "JPEG", "PNG", "GIF"]
        }
        disabled={disabled}
      />
    </Paper>
  );
}
